import script from "./ToggleSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&setup=true&lang=js"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=7fe47a76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fe47a76"]])

export default __exports__